import { useLang } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <section
      data-testid="marquee-strip"
      className="border-b border-white/10 bg-[#101012] overflow-hidden"
    >
      <div className="marquee py-6">
        {row.map((t, i) => (
          <div key={i} className="flex items-center px-8 shrink-0">
            <span className="text-[#FF3333] font-mono text-xs mr-6">◢</span>
            <span className="font-display text-2xl md:text-3xl text-white/30 tracking-tight whitespace-nowrap">
              {t}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
